import React, {useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCategories } from '../../actions/filterActions';
import arrowLeft from '../icons/Arrow_left.svg'
import default_cover from '../images/default_cover.jpg'
import { useNavigate } from 'react-router-dom';

const Categories = (props) => {

    const dispatch = useDispatch()

    const navigate = useNavigate()

        const {categories} = useSelector(state=>state.categories)
    
        useEffect(()=>{
    
            if (!categories || !categories.length)  
            {
                dispatch(getCategories())
            }
        },[dispatch])


    const clickHandler = (tag) => {
        navigate(`/category/${tag.title}/${tag.id}`)
    }

    return (
        <div className='w-100 d-flex flex-column align-items-center bg-bluedark pt-0 pt-md-3'>
            <div className='col-11 col-lg-10 d-flex flex-column align-items-center'>
                <div className = 'w-100 d-flex justify-content-center pt-3 pt-md-5 pb-2'>
                    <div className = 'col-12 pb-2 col-lg-10 d-flex'>
                        <img 
                            src = {arrowLeft} 
                            role = 'button'
                            onClick={()=>navigate(-1)}
                            alt = ''/>
                        <div className='ps-3 text-white fs-7 page-title'>Categories</div>
                    </div>
                </div>
                <div className = 'w-100 d-flex flex-wrap justify-content-center'>
                    {
                        categories && categories.length ? categories.map((category, index)=>(
                                <div key = {category.id}
                                    className = "col-6 col-md-4 col-lg-3 p-3 d-flex align-items-start"
                                    onClick={()=>clickHandler(category)}
                                    >
                                    <div className='w-100' >
                                        <div className='position-relative'
                                        >
                                            <img src={ `https://img.cugate.com/?o=CUTV_CATEGORY&i=${category.id}&s=600`} alt = ""
                                                onError = {({ currentTarget }) => {
                                                    currentTarget.onerror = null // prevents looping
                                                    currentTarget.src=default_cover
                                                }}
                                                role='button'
                                                className='w-100 px-1'
                                                style={
                                                    {
                                                        objectFit: 'cover',
                                                        borderRadius:'0.625vw',
                                                        aspectRatio: "16/9"
                                                    }
                                                }>
                                                </img>
                                        </div>
                                    </div> 
                                </div>
                        )) : <div className='text-info'>Loading...</div>
                    }
                </div>
            </div>  
            
        </div>
    );
};

export default Categories;